import React, { Component } from 'react';
import PT from 'prop-types';
import { forEach } from 'lodash';
import cIf from 'classnames';
import { getPropertyValue } from '../util';

export class FormContainerView extends Component {
    render() {
        return (
            <div className="row">
                <div className="col-xs-12">
                    {this.props.cartFormCtls}
                    {this.props.orderFormCtls}
                    {this.props.ticketFormsCtls}

                    {this.props.errorsMessages}
                    <div className="btn-toolbar pull-right">
                        <button type="button" className="btn btn-primary" onClick={this.props.onSubmit}>{this.props.submitButtonTitle}</button>
                        <button type="button" className="btn btn-default" onClick={this.props.onCancel}>{this.props.cancelButtonTitle}</button>
                    </div>
                </div>
            </div>
        );
    }
}
FormContainerView.propTypes = {
    cartFormCtls: PT.object, // What's that?
    orderFormCtls: PT.object, // What's that?
    ticketFormsCtls: PT.object, // What's that?
    errorsMessages: PT.object, // What's that?
    onSubmit: PT.object, // What's that?
    onCancel: PT.object, // What's that?
    submitButtonTitle: PT.string, // What's that?
    cancelButtonTitle: PT.string // What's that?

};

export class FormChildrenView extends Component {
    render() {
        return (
            <div>
                <h2>{this.props.formName}</h2>
                <ul className="list-inline">
                    <li style={{verticalAlign:"top"}}>
                        <h3 style={{marginTop:"5px"}}>{this.props.ticketDescription}</h3>
                    </li>
                    {this.props.buttons}
                </ul>
                <p>{this.props.formDescription}</p> 
                <br/>
                {this.props.children}
            </div>
        );
    }
}
FormChildrenView.propTypes = {
    formName: PT.string,
    buttons: PT.object, // What's that for?
    formDescription: PT.string,
    ticketDescription: PT.string
};

export class FormGroupWrapperView extends Component {
   
    render() {
        let validationState;
        const helpBlocks = [];

        if(this.props.showValidationErrors) {
            validationState = this.props.validationErrors.length > 0;

            forEach(this.props.validationErrors, (err) => {
                const errorMessage = this.props.validator.translate(err.type);
                helpBlocks.push(<div key={err.type} className="help-block invalid-feedback">{errorMessage}</div>);
            });
        }

        const helpText = getPropertyValue(this.props.helpText, this.props.lang);
        helpBlocks.push(<div key="help" className="help-block">{helpText}</div>);

        const label = getPropertyValue(this.props.label, this.props.lang);
        return (
            <div title={this.props.example} className={cIf("form-group", { "has-error": validationState, "hidden": this.props.isVisibled === false })}>
                <label className="control-label">{label}</label>
                {this.props.children}
                {helpBlocks}
            </div>
        );
    }
}
FormGroupWrapperView.propTypes = {
    showValidationErrors: PT.bool, // What's that?
    validationErrors: PT.arrayOf(PT.shape({
        type: PT.string,
    })),
    helpText: PT.oneOf([PT.string, PT.shape({ fr: PT.string, en: PT.string })]),
    label: PT.oneOf([PT.string, PT.shape({ fr: PT.string, en: PT.string })]),
    example: PT.string,
    isVisibled: PT.bool, // Typo here
    validator: PT.func, // What's that?
    lang: PT.string
};

export class FormFieldListView extends Component {
    render() {
        return (
            <div style={{marginLeft: this.props.indentation * 15}}>
                {this.props.children}
            </div>
        );
    }
}
FormFieldListView.propTypes = {
    indentation: PT.number // Number of indentation
};
FormFieldListView.defaults = {
    indentation: 0
};
